import React, {useState, useEffect} from 'react';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import Link from '@mui/material/Link';
import {Container, Grid, Button} from '@mui/material'
import {PeriodService} from '../shared/service';
import CustomDataGrid from '../../../customUtil/DataGrid';
const columns = [
    {
        field: 'name', headerName: 'Name', width: 230,
        renderCell: (params) => (
            <Link style={{textDecoration: 'none'}} component={RouterLink} to={'/gas/reporting-period/' + params.row.id}>
                {params.value}
            </Link>
        )
    },
    {field: 'startDate', headerName: 'Start Date', width: 100},
    {field: 'endDate', headerName: 'End Date', width: 100},
    {field: 'current', headerName: 'Current Period', width: 100}
]

const ReportingPeriods = () => {
        const [list, setList] = useState([]);
        const history = useHistory();

        useEffect(() => {
            PeriodService.getAll()
                .then((response) => {
                    setList(response.data);
                });
        }, []);

        return (
            <Container>
                <header>
                    <h1>Reporting Periods</h1>
                </header>
                    <Grid container spacing={5}>                      
                        <Grid item xs={12}>
                        <Button variant='contained' color='primary' onClick={() => {history.push('/gas/reporting-period/new')}}>Create New</Button>
                        </Grid>  
                        <Grid item xs={12}>
                        <CustomDataGrid 
                                rows={list}
                                columns={columns}
                                rowHeight={35}
                                />
                        
                        </Grid>
                    </Grid>
                  
            </Container>
        );
    }
;

export default ReportingPeriods;
